<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(color="grey darken-4")
  v-container(fluid)
    v-row(justify="center")
      v-col(cols=12 sm=8 md=12)
        v-row(justify="space-around" align="center")
          v-col(cols=12 md=6)
            h3.mb-6.mb-md-16.ibm.text-h4.text-md-h3.white--text Multiplique suas vendas mensais de 10 a 100 vezes!
            v-btn.mb-2.mb-md-0.px-md-16.heebo.text-body-1.font-weight-medium.white--text.text-none(
              v-if="$vuetify.breakpoint.mdAndUp"
              color="accent"
              depressed
              height=56
              @click="$goTo({ path: '/', target: '#selectInst' })"
            ) Quero aumentar minhas vendas!
          v-col(cols=12 md=6 lg="auto")
            v-card.pa-2.pa-lg-6(
              color="transparent"
              flat
              style="border: 1px solid white !important; border-radius: 12px"
            )
              v-container
                v-row(justify="center" align="center")
                  v-col.d-flex.justify-center(cols=12 md="auto")
                    div
                      v-img.mr-lg-3.rounded-circle(
                        src="../../assets/clients/iepsis.png"
                        alt="Imagem cliente IEPSIS"
                        :width="$vuetify.breakpoint.smAndDown ? 100 : 120"
                        :height="$vuetify.breakpoint.smAndDown ? 100 : 120"
                      )
                  v-col.d-flex.justify-center.justify-lg-start
                    div(style="max-width: 40ch")
                      p.mb-4.text-body-1.text-md-h6.font-weight-regular.heebo.white--text “Já no meu primeiro curso dentro do Erudio, faturei R$ 10 mil. Agora estou me preparando para os R$ 100 mil.”
                      .text-body-1.text-md-h6.font-weight-regular.ibm.grey--text.text--lighten-1 - Mulher do IEPSIS
            v-btn.mt-12.mb-2.mb-md-0.px-md-16.heebo.text-body-1.font-weight-medium.white--text.text-none(
              v-if="$vuetify.breakpoint.smAndDown"
              color="accent"
              block
              depressed
              height=56
              @click="$goTo({ path: '/', target: '#selectInst' })"
            ) Quero aumentar minhas vendas!
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
